// Rating label utilities for converting DB enums to display labels
// Keys match database ENUMs: rating_taste, rating_portion, rating_value

export const tasteLabels: Record<string, string> = {
  meh: '😐 Meh',
  solid: '👍 Solid',
  fire: '🔥 Fire',
  life_changing: '🤯 Life-Changing',
};

export const portionLabels: Record<string, string> = {
  snack_attack: '🐜 Snack Attack',
  just_right: '👌 Just Right',
  food_coma: '😴 Food Coma',
};

export const valueLabels: Record<string, string> = {
  steal: '🤑 Steal!',
  fair_deal: '⚖️ Fair Deal',
  splurge: '💰 Splurge',
  daylight_robbery: '💸 Daylight Robbery',
};

export function getTasteLabel(key: string | null): string | null {
  if (!key) return null;
  return tasteLabels[key] || key;
}

export function getPortionLabel(key: string | null): string | null {
  if (!key) return null;
  return portionLabels[key] || key;
}

export function getValueLabel(key: string | null): string | null {
  if (!key) return null;
  return valueLabels[key] || key;
}

// Tag emoji mapping for display
export const tagEmojis: Record<string, string> = {
  spicy: '🔥 Spicy',
  healthy: '🌿 Healthy',
  hidden_gem: '💎 Hidden Gem',
  good_value: '💰 Good Value',
  insta_worthy: '📸 Insta-Worthy',
  great_leftovers: '🥡 Great Leftovers',
  authentic: '🧑‍🍳 Authentic',
  comfort_food: '☁️ Comfort Food',
};

export function getTagLabel(key: string): string {
  return tagEmojis[key] || key;
}
